import { Theme } from "@remo-co/ui-core/src/types";

export const styles = {
  container: {
    color: "text.primary",
    "& .MuiPaper-root": {
      width: "450px",
      borderRadius: "5px",
      padding: "20px",
      backgroundColor: "events.grayShade2",
      boxShadow: (theme: Theme) =>
        `4px 4px 4px 0px ${theme.palette.boxShadow.default}`,
    },
    "& .MuiDialogTitle-root": {
      padding: "0px !important",
      height: 30,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "& h6": {
        fontWeight: "500",
        fontSize: "20px",
      },
    },
    "& .MuiSvgIcon-root": {
      color: "text.primary",
    },
  },
  subtitle: {
    color: "text.primary",
    marginTop: "10px",
  },
  label: {
    color: "text.primary",
    marginBottom: "4px",
    fontWeight: "500",
  },
  text: {
    border: "1px solid",
    borderColor: "events.grayShade1",
    boxShadow: (theme: Theme) =>
      `4px 4px 4px 0px ${theme.palette.boxShadow.default}`,
    borderRadius: "5px",
    "& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline":
      {
        border: "none !important",
      },
  },

  border: {
    "&:hover, &:focus": {
      borderColor: (theme: Theme) =>
        `${theme.palette.border.default} !important`,
    },
    "&.Mui-focused": {
      borderColor: (theme: Theme) =>
        `${theme.palette.border.default} !important`,
    },
  },

  buttontext: {
    width: "100px",
    display: "flex",
    justifyContent: "space-between",
  },

  input: {
    paddingTop: "20px",
    paddingRight: "10px",

    text: {
      maxHeight: "50px",
    },
  },

  permission: {
    display: "flex",
  },

  dropdownButton: {
    width: "100%",
    textAlign: "left",
    color: "text.primary",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "55px",

    "& .MuiTypography-root": {
      padding: "0px",
      width: "100%",
      textAlign: "left",
      "& div": {
        width: "100%",
      },
    },
  },

  buttonContainer: {
    paddingRight: "10px",
    backgroundColor: "events.grayShade2",
    color: "text.primary",
    "& button": {
      backgroundColor: "events.whiteTertiary",
      borderRadius: "4px",
      paddingLeft: "12px",
      paddingRight: "4px",
      border: "1px solid",
      borderColor: "events.grayShade1",
      "&:hover": {
        backgroundColor: "events.whiteTertiary",
      },
    },

    text: {
      maxHeight: "50px",
    },
  },

  placeholderText: {
    width: "100%",
    color: "text.primary",
    fontSize: "14px",
    margin: "0px",
    "& .MuiTypography-root": {
      width: "100%",
      textAlign: "left",
    },
  },
  chevron: {
    width: "24px",
    height: "24px",
    marginLeft: "auto",
    color: "text.primary",
  },

  popover: {
    "& .MuiList-root": {
      padding: "0px",
      width: "100%",
    },
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: "438px",
      boxShadow: (theme: Theme) =>
        `4px 4px 4px 0px ${theme.palette.boxShadow.default}`,
    },
  },
  list: {
    height: "60px",
    padding: "10px 13px",
  },
  selected: {
    height: "60px",
    padding: "10px 13px",
    backgroundColor: "events.grayShade1",
  },
  time: {
    fontSize: "12px",
    lineHeight: "21px",
  },
  title: {
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: 500,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overFlow: "hidden",
  },

  desc: {
    fontSize: "12px",
    lineHeight: "21px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overFlow: "hidden",
  },

  formCtn: {
    minHeight: "510px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  action: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "20px",
    paddingRight: "10px",
  },
  cancel: {
    minWidth: "130px",
    minHeight: "40px",
  },
  submit: {
    minWidth: "160px",
    minHeight: "40px",
  },
};
